import React from 'react';
import { getConfiguration } from '../../data/utils';
import CheckBetWidget from './CheckBetWidget';
import ControlPanel from './ControlPanel';
import LastTicketWidget from './LastTicketWidget';
import { UserContext } from '../../data/betslip/UserConf';
import { ControlPanelContext } from '../../data/control-panel-context/ControlPanelConf';
import { PvrContext } from '../../data/pvr/PvrConf';
import RecentWinnings from './RecentWinnings';
import BetslipBanners from '../BetslipBanners';
import FrameGame from '../integrations/FrameGame';
import PvrSection from '../pvr-components/PvrSection';
import { systemCode } from '../..';
import NewsTarget from '../live-tv/NewsTarget';

function getWidgetsOrder(widgets) {
    if (widgets == null) {
        return ['CP', 'PVR', 'CBET', 'R', 'L', 'LT', 'RW', 'BB'];
    } else {
        return widgets;
    }
}

function WidgetsContainer(props) {
    const conf = getConfiguration();
    const controlPanelContext = React.useContext(ControlPanelContext);
    const pvrContext = React.useContext(PvrContext);
    const userContext = React.useContext(UserContext);
	
    const showControlPanel = controlPanelContext.enabled;
    
    const pageData = props.pageData;
    const frameGames = conf.bfs;
    const mountPvrSection = pvrContext.pvrSectionEnabled;
	const showFrames = !mountPvrSection && frameGames && frameGames.fms.length > 0;

    let loadLastTicketsComponent = false;
    let lastTickets = null;
    const user = userContext.getUser();
    if (user.logged) {
    	lastTickets = userContext.getLastTickets();
    	// loading also if conf.lte = false, because I need the function "reloadTicket" in the window.
    	// Its html will be shown just if conf.lte = true
    	loadLastTicketsComponent = lastTickets != null;
    }

    return (
        <>
            {getWidgetsOrder(conf.bwo).map((w, i) => {
                if (w === 'CP' && showControlPanel) {
                    return <ControlPanel key={i} />
                } else if (w === 'PVR' && mountPvrSection) {
                    return <PvrSection key={i} />
                } else if (w === 'CBET' && conf.cwe) {
                    return <CheckBetWidget key={i} />
                } else if (w === 'R' && showFrames) {
                    return (
                        <React.Fragment key={i}>
                            {frameGames.fms.map((frameGame, i) => {
                                if (frameGame.enbd) {
                                    return <FrameGame key={`frameGame-${i}`} frameGame={frameGame} />	                    				
                                } else {
                                    return null
                                };
                            })}
                        </React.Fragment>
                    );
                } else if (w === 'LT' && loadLastTicketsComponent) {
                    return <LastTicketWidget key={i} lastTickets={lastTickets} />
                } else if (w === 'RW' && pageData != null && pageData.recentWinnings.length > 0) {
                    return <RecentWinnings key={i} data={pageData.recentWinnings} />
                } else if (w === 'BB' && pageData != null && pageData.cart.bottomBanners.length > 0) {
                    return <BetslipBanners key={i} banners={pageData.cart.bottomBanners} />
                } else {
                    return null;
                }
            })}
            {systemCode === 'NETBET' && 
                <div id="netbet-esa-container" ></div>
            }
            <NewsTarget />
        </>
    );
}

export default WidgetsContainer;
